import { Button, Col, DatePicker, Form, Row, Select } from "antd";
import moment from "moment";

moment.locale("es");
const { Option } = Select;
const dateFormat = "DD MMM YYYY";

export const CourtForm = ({
  form,
  onFinish,
  onFinishFailed,
  requestCities,
  countries,
  cities,
  activityTypes,
  onActivityTypeChange,
  initialDateTime,
  disabledDate,
  updateSelectedDate,
  calendarReservations,
  loadCalendarReservations,
  onCityChange,
}) => {
  return (
    <Form
      form={form}
      name="landingSearch"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="horizontal"
    >
      <Row className="Row-Select--menu" gutter={[16, 16]}>
        <Col className="Col-first--SelectButtom Col-content--select col-1">
          <Form.Item name="country" help="" rules={[{ required: true }]}>
            <Select
              className="firstSelect"
              placeholder="Selecciona el país"
              style={{
                borderRadius: "40px",
              }}
              onChange={requestCities}
              suffixIcon={<span>&#9660;</span>}
            >
              {countries.length > 0 &&
                countries.map((country) => (
                  <Option key={country.idpais} value={country.idpais}>
                    {country.nombre}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col className="Col-content--select col-2">
          <Form.Item name="city" help="" rules={[{ required: true }]}>
            <Select
              notFoundContent="No hay datos"
              className="selectMenu"
              placeholder="Ciudad"
              suffixIcon={<span>&#9660;</span>}
              onChange={onCityChange}
            >
              {cities.length > 0 &&
                cities.map((city) => (
                  <Option key={city.idciudad} value={city.idciudad}>
                    {city.nombre}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col className="Col-content--select col-3">
          <Form.Item name="activityType" help="" rules={[{ required: true }]}>
            <Select
              notFoundContent="No hay datos"
              className="activityTypeSelect"
              placeholder="Tipo de actividad"
              suffixIcon={<span>&#9660;</span>}
              onChange={onActivityTypeChange}
            >
              {activityTypes.length > 0 &&
                activityTypes.map((activityType) => (
                  <Option key={activityType.id} value={activityType.id}>
                    {activityType.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col className="Col-content--select col-5">
          <Form.Item
            name="date"
            help=""
            rules={[{ required: true }]}
            initialValue={initialDateTime.date}
          >
            <DatePicker
              inputReadOnly
              placeholder="Fecha"
              allowClear={false}
              format={dateFormat}
              disabledDate={disabledDate}
              onChange={updateSelectedDate}
              dateRender={(currentDate) => {
                const dateStr = currentDate.format("YYYY-MM-DD");
                const isClasses = form.getFieldValue("activityType") === "clases";
                const hasReservation = isClasses && calendarReservations?.has(dateStr);
                return (
                  <div className="ant-picker-cell-inner" style={{ position: "relative" }}>
                    {currentDate.date()}
                    {hasReservation && <div className="calendar-tile-dot" />}
                  </div>
                );
              }}
              onPanelChange={(value) => loadCalendarReservations?.(value)}
            />
          </Form.Item>
        </Col>
        <Col className="Col-first--SelectButtom Col-content--select col-7">
          <Form.Item>
            <Button className="buttonSearch" type="primary" htmlType="submit">
              Buscar
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
